<template>
    <v-container fluid>
        <v-overlay :value="loading" z-index="10000">
            <v-progress-circular indeterminate size="64" ></v-progress-circular>
            <span class="loading">処理中です...</span>
        </v-overlay>
        
        <!-- 検索パネル -->
        <!-- <v-row justify="center">
            <v-col cols="11">
                
            </v-col>
            <v-col justify="center" v-bind:class="{ active : show }" class="searchLabel" @click="show = !show">
                <v-icon v-if="!show" justify="center" class="positfixed" x-large>
                    mdi-text-box-search
                </v-icon>
                <v-icon v-if="show" justify="center" class="positfixed" x-large>
                    mdi-close-box
                </v-icon>
            </v-col>
        </v-row> -->
        
        <v-row>
            <v-col cols="12">
                <label-component fontSize="30" fontWeight="bold">共有キャビネット</label-component>
            </v-col>
            <v-col cols="12"></v-col>
        </v-row>

        <!-- ページネーション -->
        <v-row>
            <v-col class="align-self-end" no-gutters>
                <template v-if="depthInfo.is_show">
                    <v-row class="mb-2" no-gutters>
                        <v-col cols="auto" class="mx-2">
                            <v-btn color="blue" class="white--text" style="height:36px !important;" @click="itemAction(root)"><v-icon left>mdi-arrow-collapse-up</v-icon>トップに戻る</v-btn>
                        </v-col>
                        <v-col cols="auto" class="mx-2" v-if="depthInfo.parent_item != null">
                            <v-btn color="blue" class="white--text" style="height:36px !important;" @click="itemAction(depthInfo.parent_item)"><v-icon left>mdi-arrow-up</v-icon>上の階層に戻る</v-btn>
                        </v-col>
                    </v-row>
                    <p>文書管理トップ
                        <span v-for="(folderPath, index) in folderPathArray" :key="index">
                            <v-icon>mdi-chevron-right</v-icon>
                            {{ folderPath }}
                        </span>
                    </p>
                </template>
            </v-col>
            <v-col cols="auto" class="align-self-end" offset-sm="0" offset-xs="0">
                <v-pagination
                    v-model="indexInfo.page"
                    :length="indexInfo.pageCount"
                ></v-pagination>
            </v-col>
            <v-col class="text-right align-self-end" style="min-width: 250px;" no-gutters>
                <button-component v-if="navi.plan == true && enableCabinetBtn" color="orange" @click="dialog.createCabinet = true" width="280"><v-icon large left class="button-margin-left">mdi-archive</v-icon>キャビネット作成</button-component>
                <button-component v-else-if="navi.plan == true && enableFolderBtn" color="orange" @click="dialog.createfolder = true"><v-icon large left class="button-margin-left">mdi-folder</v-icon>フォルダ作成</button-component>
            </v-col>
        </v-row>
        
        <!-- データテーブル -->
        <v-row no-gutters justify="center">
            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="items"
                    item-key="index"
                    @page-count="indexInfo.pageCount = $event"
                    :items-per-page="indexInfo.itemsPerPage"
                    :page.sync="indexInfo.page"
                    :loading="loading"
                    hide-default-footer
                    :validCabinetIds="validCabinetIds"
                    :sort-by="['is_all_documents_cabinet', 'is_cabinet', 'isFolder', 'last_update_signature_datetime', 'agreements_or_folders_id']"
                    :sort-desc="[true, true, true, true, false]"
                    multi-sort
                >
                    <template v-slot:body="props">
                        <tbody>
                            <tr v-for="(item, index) in props.items" :key="index">
                                <td class="item-td" :class="(item.is_cabinet && !validCabinetIds.includes(item.agreements_or_folders_id))? 'disableCabinet' : ''" align="center" width="10%" @click.left="itemAction(item)">
                                    <progress-status-component v-if="!item.isFolder && (item.is_uploaded_contract == 0)" :agreeCnt="item.agree_cnt" :allCnt="item.all_cnt" :rejected="item.status == contractStauses['STATUS_REJECTED']"></progress-status-component>
                                </td>
                                <td class="item-td" :class="(item.is_cabinet && !validCabinetIds.includes(item.agreements_or_folders_id))? 'disableCabinet' : ''" align="left" width="21%" @click.left="itemAction(item)">
                                    <v-icon x-large>{{ getViewIcon(item) }}</v-icon>
                                    {{ item.name }}
                                    <div v-if="item.isFolder || (item.is_uploaded_contract == 1)" class="second-row">
                                        <div class="sendTo"></div>
                                        <div class="sendTo"></div>
                                    </div>
                                    <div v-else class="second-row">
                                        <!-- 送信者 -->
                                        <div class="sendTo from">From</div>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span
                                                class="info-to"
                                                v-bind="attrs"
                                                v-on="on"
                                                >
                                                    {{ item.from_name }}
                                                </span>
                                            </template>
                                            <span>{{ item.from_name }}</span>
                                        </v-tooltip>
                                        <!-- 受信者 -->
                                        <div class="sendTo to">To</div>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span class="info-to" v-bind="attrs" v-on="on" >
                                                    {{ getDestNames(item.isFolder, item.agreements_id) | omittedText30 }}
                                                </span>
                                            </template>
                                            <span>{{ getDestNames(item.isFolder, item.agreements_id) }}</span>
                                        </v-tooltip>
                                    </div>
                                </td>
                                <td class="item-td" :class="(item.is_cabinet && !validCabinetIds.includes(item.agreements_or_folders_id))? 'disableCabinet' : ''" align="center" width="20%" @click.left="itemAction(item)">{{ getStartDate(item) }}{{ getEndDate(item) }}</td>
                                 <!-- アラート -->
                                <td align="center" :class="(item.is_cabinet && !validCabinetIds.includes(item.agreements_or_folders_id))? 'disableCabinet' : ''" width="10%">
                                    <!-- 契約書 かつ アラート設定権限がある場合、-->
                                    <div  v-if="!item.isFolder && alertAuths.find(contractId => contractId == item.agreements_or_folders_id)">
                                        <!-- アラート設定がない場合はアラート設定ボタン、設定の場合はベルアイコン　-->
                                        <v-btn v-if="!item.contract_alerts_id" 
                                            @click.stop="clickAlert(item)" class="white--text" color="orange">アラート設定</v-btn>
                                        <v-btn v-else
                                            icon @click.stop="clickAlert(item)" class="white--text" color="orange">
                                            <v-icon>{{ item.alert_on_off == "1" ? "mdi-bell-ring" : "mdi-bell-off" }}</v-icon>
                                        </v-btn>
                                    </div>
                                </td>
                                <td class="item-td" :class="(item.is_cabinet && !validCabinetIds.includes(item.agreements_or_folders_id))? 'disableCabinet' : ''" align="center" width="14%" @click.left="itemAction(item)">
                                    <div v-if="!item.isFolder">
                                        <div>{{ item.contract_info_last_update_user_name ? item.contract_info_last_update_user_name : "" }}</div>
                                        <div>{{ getLastUpdatedContractInfoDate(item) }}</div>
                                    </div>
                                </td>
                                <td class="item-td" :class="(item.is_cabinet && !validCabinetIds.includes(item.agreements_or_folders_id))? 'disableCabinet' : ''" align="center" width="14%" @click.left="itemAction(item)">
                                    <div v-if="!item.isFolder">
                                        <div style="text-align: left;">{{ getContractStatus(item).name }}</div>
                                        <div style="text-align: left;">{{ getContractStatus(item).date }}</div>
                                    </div>
                                </td>
                                <td class="item-td" :class="(item.is_cabinet && !validCabinetIds.includes(item.agreements_or_folders_id))? 'disableCabinet' : ''" align="center" width="14%" @click.left="itemAction(item)">
                                    <div v-if="!item.isFolder">
                                        <div>{{ getNextSignerName(item) }}</div>
                                        <div>{{ getNextSignerOpenStatus(item) }}</div>
                                    </div>
                                </td>
                                <td class="item-td" align="center" width="5%">
                                    <!-- ドットメニュー 「すべての書類」の場合は表示されない -->
                                    <index-dot-menu-component
                                        :searchResult="searchResult"
                                        :agreementsOrFoldersId="item.agreements_or_folders_id"
                                        :cabinet="item.is_cabinet" :folder="item.isFolder"
                                        :currentFolderIsAllDocCabinet="false"
                                        :importFile="item.is_uploaded_contract"
                                        @clickDelete="clickDotMenuDelete(item)" @clickRename="clickDotMenuRename(item)"
                                        @clickShare="clickDotMenuShare(item)" @clickDeleteShare="clickDotMenuDeleteShare(item)"
                                        @clickMove="clickDotMenuMove(item)" @clickEditMemberGroup="clickEditMemberGroup(item, $event)"
                                        @clickDeleteImportFile="clickDotMenuDelete(item)">
                                    </index-dot-menu-component>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        
        <!-- フローティング 検索パネル -->
        <v-row no-gutters>
            <v-col col="12" >
                <template>
                    <div class="w50per">
                        <transition name="slide">
                            <p v-show="show">
                                <v-card>
                                    <v-navigation-drawer permanent position: fixed float: right width="50%">
                                        <br>
                                        <v-container>
                                                <v-row>
                                                    <br>
                                                </v-row>
                                                <v-row>
                                                    <br>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" xl="12" class="text-center positfixedSearch">
                                                        <button-component @click="search" color="blue">検索</button-component>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <br>
                                                </v-row>
                                                <v-row>
                                                    <br>
                                                </v-row>
                                                <v-row>
                                                    <br>
                                                </v-row>
                                                <v-row class="search-item no-gutters">
                                                    <v-col cols="2">
                                                       <label-component>ステータス</label-component>
                                                    </v-col>
                                                    <v-col cols="10" class="d-flex no-gutters search-item">
                                                        <v-checkbox label="進行中" value="1" v-model="searchItem.status.progress" ></v-checkbox>
                                                        <v-checkbox label="締結済み" value="3" v-model="searchItem.status.conclusion" ></v-checkbox>
                                                        <v-checkbox label="却下" value="4" v-model="searchItem.status.rejected" ></v-checkbox>
                                                    </v-col>
                                                </v-row>
                                                <v-row class="search-item no-gutters">
                                                    <v-col cols="2">
                                                       <label-component class="no-gutters">開封状況</label-component>
                                                    </v-col>
                                                    <v-col cols="10" class="d-flex no-gutters">
                                                        <v-checkbox label="開封済" value="2" v-model="searchItem.openStatus.opened" ></v-checkbox>
                                                        <v-checkbox label="未開封" value="1" v-model="searchItem.openStatus.unopened" ></v-checkbox>
                                                    </v-col>
                                                    <v-col cols="2">
                                                        <label-component>種類</label-component>
                                                    </v-col>
                                                    <v-col cols="4" >
                                                        <v-select v-model="searchItem.type.value" :items="searchItem.type.selects"
                                                            outlined background-color="white"
                                                        ></v-select>
                                                    </v-col>
                                                    <v-col cols="2" >
                                                        <label-component class="no-gutters">件名</label-component>
                                                    </v-col>
                                                    <v-col cols="4" >
                                                        <v-text-field v-model="searchItem.contract_name" outlined clearable v-disabled-icon-focus background-color="white"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="2" >
                                                        <label-component>管理番号</label-component>
                                                    </v-col>
                                                    <v-col cols="4" >
                                                        <v-text-field v-model="searchItem.infoUpdate.controlNumber" outlined clearable v-disabled-icon-focus background-color="white"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="2" >
                                                        <label-component>取引先</label-component>
                                                    </v-col>
                                                    <v-col cols="4" >
                                                        <v-text-field v-model="searchItem.destination_company_name" outlined clearable v-disabled-icon-focus background-color="white"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" >
                                                    <v-expansion-panels accordion>
                                                        <v-expansion-panel :value="searchPaNelno">
                                                            <v-expansion-panel-header>
                                                                <p class="search-item no-gutters text-center">日付</p>
                                                            </v-expansion-panel-header>
                                                            <v-expansion-panel-content>
                                                                <v-row class="search-item no-gutters">
                                                                    <v-col cols="2" >
                                                                        <label-component>契約開始日</label-component>
                                                                    </v-col>
                                                                    <v-col cols="4" >
                                                                        <date-picker-component v-model="searchItem.startDate"></date-picker-component>
                                                                    </v-col>
                                                                    <v-col cols="2" >
                                                                        <label-component>契約終了日</label-component>
                                                                    </v-col>
                                                                    <v-col cols="4" >
                                                                        <date-picker-component v-model="searchItem.endDate"></date-picker-component>
                                                                    </v-col>
                                                                    <v-col cols="2" >
                                                                        <label-component>アラート日</label-component>
                                                                    </v-col>
                                                                    <v-col cols="4" >
                                                                        <date-picker-component v-model="searchItem.alertDate"></date-picker-component>
                                                                    </v-col>
                                                                    <v-col cols="2" >
                                                                        <label-component>契約情報更新日</label-component>
                                                                    </v-col>
                                                                    <v-col cols="4" >
                                                                        <date-picker-component v-model="searchItem.infoUpdate.date"></date-picker-component>
                                                                    </v-col>
                                                                    <v-col cols="2" >
                                                                        <label-component>最終更新日</label-component>
                                                                    </v-col>
                                                                    <v-col cols="4" >
                                                                        <date-picker-component v-model="searchItem.lastUpdate.date"></date-picker-component>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-expansion-panel-content>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <br>
                                                    <v-col cols="2" >
                                                        <label-component>契約情報更新者</label-component>
                                                    </v-col>
                                                    <v-col cols="4" >
                                                        <v-select
                                                            v-model="searchItem.infoUpdate.value"
                                                            :items="searchItem.infoUpdate.persons"
                                                            outlined
                                                            background-color="white"
                                                        ></v-select>
                                                    </v-col>
                                                    <v-col cols="2" >
                                                        <label-component>最終更新者</label-component>
                                                    </v-col>
                                                    <v-col cols="4" >
                                                        <v-select
                                                            v-model="searchItem.lastUpdate.value" :items="searchItem.lastUpdate.persons"
                                                            outlined background-color="white" text-align=left
                                                        ></v-select>
                                                    </v-col>
                                                    <v-col cols="2" >
                                                        <label-component>取引金額</label-component>
                                                    </v-col>
                                                    <v-col cols="4" >
                                                        <v-text-field v-model="searchItem.infoUpdate.fromTransactionAmount" outlined clearable v-disabled-icon-focus background-color="white"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="2" class="between-mark">～</v-col>
                                                    <v-col cols="4" >
                                                        <v-text-field v-model="searchItem.infoUpdate.toTransactionAmount" outlined clearable v-disabled-icon-focus background-color="white"></v-text-field>
                                                    </v-col>
                                                </v-row>
                                                <v-row class="search-item no-gutters">
                                                    <v-col cols="12" >
                                                        <v-expansion-panels accordion>
                                                            <v-expansion-panel :value="searchPaNelno">
                                                                <v-expansion-panel-header>
                                                                    <p class="search-item no-gutters text-center">ユーザー定義項目</p>
                                                                </v-expansion-panel-header>
                                                                <v-expansion-panel-content>
                                                                    <v-row v-for="(userItem, index) in searchItem.userItems" :key="index" class="search-item no-gutters">
                                                                        <v-col cols="4" >
                                                                            <label-component>{{ userItem['item_name'] }}</label-component>
                                                                        </v-col>
                                                                        <v-col cols="8" >
                                                                            <v-text-field v-model="userItem['value']" outlined clearable v-disabled-icon-focus background-color="white"></v-text-field>
                                                                        </v-col>
                                                                    </v-row>
                                                                </v-expansion-panel-content>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <br>
                                                </v-row>
                                                <v-row>
                                                    <br>
                                                </v-row>
                                                <v-row>
                                                    <br>
                                                </v-row>
                                            </v-container>
                                    </v-navigation-drawer>
                                </v-card>
                            </p>
                        </transition>
                    </div>
                </template>
            </v-col>
        </v-row>

        <!-- メッセージ -->
        <message-component id="message" v-model="isMessage" :success="message.success">{{ message.text }}</message-component>
        
        <!-- アラート -->
        <alert-component v-if="dialog.alert" :dialog.sync="dialog.alert" :item="editItem" @clickOk='setAlertData'/>
        
        <!-- 新規キャビネット作成ダイアログ -->
        <cabinet-create-component v-if="dialog.createCabinet" :dialog.sync="dialog.createCabinet" @clickOk="createCabinet"/>
        
        <!-- 新規フォルダ作成ダイアログ -->
        <input-dialog-component
            v-if="dialog.createfolder" v-model="dialog.createFolderText"
            :dialog.sync="dialog.createfolder" @clickOk="createFolder"
            placeholder="名前を入力してください" title="新規作成"
            validateName="名前" okBtn="作成" cnacelBtn="キャンセル">
        </input-dialog-component>
        
        <!-- 名前変更ダイアログ -->
        <input-dialog-component
            v-if="dialog.rename" v-model="dialog.renameText"
            :dialog.sync="dialog.rename" @clickOk="renameItem(editItem)"
            placeholder="名前を入力してください" title="名前の変更"
            validateName="名前の変更" okBtn="変更" cnacelBtn="キャンセル">
        </input-dialog-component>
        
        <!-- 削除確認ダイアログ -->
        <simple-dialog-component v-if="dialog.confirmDelete" :dialog.sync="dialog.confirmDelete" @clickOk="deleteItem(editItem)"
            :message="editItem.is_uploaded_contract ? '書類を削除しますか？' : editItem.name + 'を削除しますか？'" okBtn="削除" cancelbtn="キャンセル">
        </simple-dialog-component>
        
        <!-- キャビネットへ共有 登録ダイアログ -->
        <cabinet-folder-file-control-dialog-component v-if="dialog.share" :dialog.sync="dialog.share" :items="dialog.radioListItems" @pushOk="shareCabinet">
            <template v-slot>{{ dialog.shareOrMoveMessage }}</template>
            <template v-slot:btnName>共有</template>
        </cabinet-folder-file-control-dialog-component>
        
        <!-- キャビネットへ共有 削除ダイアログ -->
        <cabinet-folder-file-control-dialog-component v-if="dialog.shareDelete" :dialog.sync="dialog.shareDelete" :items="dialog.radioListItems" @pushOk="deleteShareCabine" okBtnColor="red">
            <template v-slot>{{ dialog.shareOrMoveMessage }}</template>
            <template v-slot:btnName>削除</template>
        </cabinet-folder-file-control-dialog-component>
        
        <!-- フォルダ移動 -->
        <cabinet-folder-file-control-dialog-component v-if="dialog.move" :dialog.sync="dialog.move" :items="dialog.radioListItems" :targetCabinetControl="false" @pushOk="moveFolder" okBtnColor="green">
            <template v-slot>{{ dialog.shareOrMoveMessage }}</template>
            <template v-slot:btnName>移動</template>
        </cabinet-folder-file-control-dialog-component>
        
        <!-- グループの編集ダイアログ -->
        <edit-group-component v-if="dialog.editMemberGroup" :dialog.sync="dialog.editMemberGroup"
            @updateGroup="updateGroup" :selecteds="allowedOrganis" :selects="notAllowedOrganis"
            :nonDeleteGroupIds="dialog.cabinetOwnerIds">
            グループの編集
        </edit-group-component>
    </v-container>
</template>
<script>
    import {setTimeoutCheckLogin} from '../../common/loginUtil.js';
    import moment from 'moment';
    import { mapGetters, mapMutations } from 'vuex';
    import { dateformatMixin } from '../../mixins/dateformatMixin.js';
    const DAY_OF_WEEK = [ "日", "月", "火", "水", "木", "金", "土" ];
    
    const PANEL_OPEN = 0;   // パネルの開閉
    const PANEL_CLOSE = 1;
    
    export default {
        mixins:[dateformatMixin],
        props: {
            navi: Object,
            userDefinedItems: Array,    // ユーザー定義項目
            isFromOverView: Boolean,    // 契約概要から遷移したか
            documentTypes: Object,      // 文書の種類
            contractStauses: Object,    // 契約ステータス
            openingStatuses: Object,    // 開封ステータス
            signStatuses: Object,       // 署名ステータス
            cabinetValidIds: Array      // 有効なキャビネットID
        },
        data() {
            return {
                show: false,
                drawer: true,
                mini: true,
                    
                // 検索項目
                searchItem: {
                    // ステータス
                    status: {
                        progress: null, // 進行中
                        conclusion: null, // 締結済み
                        rejected: null, // 却下
                    },
                    // 開封状況
                    openStatus: {
                        opened: null,
                        unopened: null,
                    },
                    // 種類
                    type: {
                        value: this.documentTypes['ALL_TYPE'],
                        selects : [
                            { text: '全て' , value: this.documentTypes['ALL_TYPE'] } ,
                            { text: '一般' , value: this.documentTypes['GENERAL'] } ,
                            { text: '親展書類' , value: this.documentTypes['CONFIDENTIAL'] } ,
                            { text: 'インポート書類' , value: this.documentTypes['IMPORT'] } ,
                        ],
                    },
                    // 件名
                    contract_name: null,
                    // 契約開始日
                    startDate: null,
                    // 契約終了日
                    endDate: null,
                    // アラート日
                    alertDate: null,
                    // 契約情報更新
                    infoUpdate: {
                        value: null,
                        // 管理番号
                        controlNumber: null,
                        // 取引金額 from
                        fromTransactionAmount: null,
                        // 取引金額 to
                        toTransactionAmount: null,
                        // 契約情報更新者
                        persons : [],
                        // 契約情報更新日
                        date: null,
                    },
                    // 最終更新
                    lastUpdate: {
                        value: null,
                        // 最終更新者
                        persons : [],
                        // 最終更新日
                        date: null,
                    },
                    // ユーザー定義項目
                    userItems: [],
                },
                // テーブルヘッダー
                headers: [
                    { text: "ステータス", value: "no", align: "center", width: "10%", sortable: false},
                    { text: "件名", value: "contract_name", align: "center", width: "21%", sortable: false},
                    { text: "契約情報:契約開始日～終了日", value: "memo", align: "center", width: "20%", sortable: false},
                    { text: "アラート", value: "", align: "center", width: "10%", sortable: false},
                    { text: "契約情報更新", value: "", align: "center", width: "14%", sortable: false},
                    { text: "最終確認", value: "", align: "center", width: "14%", sortable: false},
                    { text: "次の署名", value: "", align: "center", width: "14%", sortable: false},
                    { text: "", value: "", align: "center", width: "5%", sortable: false},
                ],
                // 項目一覧
                items: [],
                indexInfo: {
                    // ページ数
                    page: 1,
                    // 最大ページ数
                    pageCount: 0,
                    // 1ページあたりの項目数
                    itemsPerPage: 10,
                },
                // 編集対象の項目
                editItem: null,
                // 現在のフォルダ
                currentFolder: {
                    folder_id: null,
                    is_cabinet: false,
                    parent_folder_id: null,
                    cabinet_id: null,
                },
                // 現在表示までの階層、現在表示の名称、親のフォルダ or キャビネット 
                depthInfo: {
                    is_show: false,
                    parent_item: null,
                },
                folderPathArray: [],
                root: {
                    is_root: true
                },
                // 送信先名前
                destNames: null,
                // アクセス不許可の組織
                notAllowedOrganis: [],
                // アクセス許可された組織
                allowedOrganis: [],
                // キャビネット作成ボタン有効
                enableCabinetBtn: false,
                // フォルダ作成ボタン有効
                enableFolderBtn: false,
                // 企業管理権限で可能な機能ボタンの有効
                enableCompanyFunctionBtn: false,
                // アラートボタンが有効
                alertAuths: [],
                // 初期一覧表示かどうか
                initIndex: false,
                // フォルダ内表示かどうか
                insideFolder: false,
                // 検索結果表示かどうか
                searchResult: false,
                // パネル開閉
                searchPaNelno: PANEL_CLOSE,
                // 読込中表示
                loading: true,
                message: {
                    success: false,
                    text: "",
                },
                // ダイアログ関連
                dialog: {
                    alert: false,
                    createfolder: false,
                    createCabinet: false,
                    rename: false,
                    share: false,
                    shareDelete: false,
                    move: false,
                    shareOrMoveMessage: null,
                    editMemberGroup: false,
                    cabinetOwnerIds: [],    // 原則キャビネットのオーナー（作成元）は一つになる
                    confirmDelete: false,
                    createFolderText: null,
                    renameText: null,
                    radioListItems: null,
                },
                // sub検索条件flag
                addDialog: false,
                fixedStyles:{
                    position: 'fixed',
                    top: '50%',
                    width: '8em',
                    right: '0%',
                    marginTop: '-2.5em',
                },
                // 有効なキャビネットIDリスト
                validCabinetIds: [],
            };
        },
        created() {
            setTimeoutCheckLogin();
            this.handleScroll();
        },
        computed: {
            // ...mapGetters(['getDocumentIndexInfoSearchItem']),
            isMessage: {
                get() {
                    return this.message.text != '';
                },
                set(value) {
                    if (!value) {
                        this.message.text = '';
                    }
                }
            },
        },
        filters: {
            omittedText30(text) {
             // 30文字目以降は"…"
             return text.length > 30 ? text.slice(0, 30) + "…" : text;
            }
        },
        mounted() {
             // scroll位置の取得
            window.addEventListener('scroll', this.handleScroll);
            // ユーザー定義項目
            if (this.userDefinedItems.length > 0) {
                for (let i = 0; i < 10; i++) {
                    if (this.userDefinedItems[i]['is_required'] != 0) {
                        this.searchItem.userItems.push({item_name: this.userDefinedItems[i]['item_name'], value: null});
                    }
                }
            }
            window.addEventListener('scroll', this.handleScroll);
            let infos = JSON.parse(sessionStorage.getItem('documentIndexInfos'));
            if (this.isFromOverView && infos?.documentIndexInfos?.searchResult) {
                // 検索条件が存在するときは、セットして実行
                this.searchItem = infos.documentIndexInfos.searchItem?? this.searchItem;
                this.indexInfo.itemsPerPage = infos.documentIndexInfos.itemsPerPage?? this.indexInfo.itemsPerPage;
                this.search();
                
            } else {
                // 初期表示
                this.getViewIndexItems();
                // 初期値がVuexに保存される
                this.resetSearchItem();
                this.saveDocumentIndexInfos();
            }
            this.validCabinetIds = this.cabinetValidIds?? [];
        },
        beforeDestroy: function() {
            window.removeEventListener('scroll', this.handleScroll);
        },
        methods: {
            handleScroll() {
                if (!this.$refs.sideHeight) {
                    return;
                }
                let sideHeight = this.$refs.sideHeight.clientHeight;
                let bodyHeight = document.body.clientHeight;
                let winHeight = window.innerHeight;
                if (winHeight < sideHeight) {
                    if (
                    bodyHeight - window.pageYOffset - winHeight <
                    sideHeight - winHeight
                    ) {
                    this.isScrollEnd = true;
                    } else {
                    this.isScrollEnd = false;
                    }
                } else {
                    this.isScrollEnd = false;
                }
                return;
            },
            // 一覧表示取得
            async getViewIndexItems() {
                this.loading = true;
                
                // 現在のフォルダの情報は初期化
                this.currentFolder.folder_id = null;
                this.currentFolder.is_cabinet = null;
                this.currentFolder.parent_folder_id = null;
                this.currentFolder.cabinet_id = null;
                
                await window.axios.get('/documents/document-management/view-index-items').then(res => {
                    // 項目一覧をセット
                    this.items = res.data.items;
                    
                    this.searchItem.lastUpdate.persons = res.data.user_last_update_selects;
                    this.searchItem.infoUpdate.persons = res.data.user_contract_info_selects;
                    this.destNames = res.data.names;
                    this.enableCabinetBtn = res.data.is_create_cabinet;
                    this.enableCompanyFunctionBtn = res.data.is_user_defined;
                    this.alertAuths = res.data.alert_auths;
                    
                    this.depthInfo = res.data.depthInfo?? this.depthInfo;

                }) .finally(() => {
                    this.loading = false;
                    this.insideFolder = false;
                    this.initIndex = true;
                    this.resetSearchItem();
                });
            },
            // 項目のアクション
            async itemAction(item, isInitPage = true) {
                // トップに戻る
                if (item != null && item.is_root != null && item.is_root == true) {
                    this.indexInfo.page = 1;
                    this.getViewIndexItems();
                    return;
                }
                if ((item != null) && !item.isFolder) {
                    // 契約クリック時
                    window.location.href = "/documents/document-management/view/" + item.agreements_object_id;
                    return;
                }
                if (isInitPage) {
                    // 最初のページを表示
                    this.indexInfo.page = 1;
                }
                if (item != null) {
                    if ((item.is_cabinet && !this.validCabinetIds.includes(item.agreements_or_folders_id))) {
                        this.message.text = '閲覧権限がありません';
                        this.message.success = false;
                        return;
                    }
                    //// 現在位置のフォルダ情報をセット /////
                    this.currentFolder.folder_id = item.agreements_or_folders_id;
                    this.currentFolder.is_cabinet = Boolean(item.is_cabinet);
                    
                    // 下の階層の親フォルダID = 今クリックしたフォルダID
                    this.currentFolder.parent_folder_id = item.agreements_or_folders_id;
                    
                     // キャビネット直下の場合はID、フォルダ配下の場合はフォルダの属すキャビネットID
                    this.currentFolder.cabinet_id = item.is_cabinet ? item.agreements_or_folders_id : item.cabinet_id;
                }
                this.loading = true;
                    await window.axios.get('/documents/document-management/view-inside-folder',{
                        params: {
                            folder_id: this.currentFolder.folder_id,
                            is_cabinet: this.currentFolder.is_cabinet,
                            parent_folder_id: this.currentFolder.folder_id,
                            cabinet_id: this.currentFolder.cabinet_id,
                        }
                    }).then(res => {
                        // 項目一覧をセット
                        this.items = res.data.items;
                        
                        this.destNames = res.data.names;
                        this.enableCabinetBtn = false;
                        this.enableCompanyFunctionBtn = false;
                        this.enableFolderBtn = res.data.is_create_folder;
                        this.alertAuths = res.data.alert_auths;
                        
                        this.depthInfo = res.data.depthInfo?? this.depthInfo;
                        this.folderPathArray = res.data.folderPath?? this.folderPathArray;
                    });
                this.loading = false;
                this.insideFolder = true;
                this.initIndex = false;
                this.resetSearchItem();
            },
            // 新規キャビネット作成
            createCabinet(oraganizationId, nameText) {
                window.axios.post('/documents/document-management/create-folder' ,{
                    name: nameText,
                    parent_folder_id: null,
                    cabinet_id: null,
                    is_cabinet: 1,
                    organization_id: oraganizationId,
                }).then(res => {
                    if (res.data.success) {
                        this.items.push(res.data.folder);
                        this.validCabinetIds = res.data.cabinetValidIds?? this.validCabinetIds;
                        this.message.text = res.data.message;
                        this.message.success = true;
                    } else {
                        this.message.success = false;
                        this.message.text = res.data.message;
                    }
                }).catch(err => {
                    this.message.text = err.data.message;
                });
            },
            // 新規フォルダ作成
            createFolder() {
                axios.post('/documents/document-management/create-folder' ,{
                    name: this.dialog.createFolderText,
                    parent_folder_id: this.currentFolder.parent_folder_id,
                    cabinet_id: this.currentFolder.cabinet_id,
                    is_cabinet: 0,
                    organization_id: null,
                }).then(res => {
                    if (res.data.success) {
                        this.items.push(res.data.folder);
                        this.message.text = res.data.message;
                        this.message.success = true;
                    } else {
                        this.message.success = false;
                        this.message.text = res.data.message;
                    }
                }).catch(err => {
                    this.message.text = err.data.message;
                }).finally(() => {
                    this.dialog.createFolderText = null;
                });
            },
            // 名前変更
            renameItem(item) {
                axios.post('/documents/document-management/rename/' + item.agreements_or_folders_id ,{
                    rename: this.dialog.renameText,
                    isFolder: item.isFolder,
                }).then(res => {
                    if (res.data.success) {
                        let index = this.items.indexOf(item);
                        this.items[index]["name"] = res.data.rename;
                        this.message.text = res.data.message;
                        this.message.success = true;
                    } else {
                        this.message.success = false;
                        this.message.text = res.data.message;
                    }
                }).catch(err => {
                    this.message.text = err.data.message;
                }); 
            },
            // 削除
            deleteItem(item) {
                axios.post('/documents/document-management/delete/' + item.agreements_or_folders_id ,{
                    name: item.name,
                    isFolder: item.isFolder,
                    isCabinet: item.is_cabinet,
                    parentFolderId: this.currentFolder.folder_id,
                    isUploadedContract: item.is_uploaded_contract
                }).then(res => {
                    if (res.data.success) {
                        // 一覧から削除
                        let index = this.items.indexOf(item);
                        this.items.splice(index, 1);
                        this.message.text = res.data.message;
                        this.message.success = true;
                    } else {
                        this.message.success = false;
                        this.message.text = res.data.message;
                    }
                }).catch(err => {
                    this.message.text = err.data.message;
                }); 
            },
            // キャビネットへ共有
            shareCabinet(cabinetId) {
                axios.post('/documents/document-management/share-contract/' + cabinetId ,{
                    contract_id : this.editItem.agreements_or_folders_id,
                }).then(res => {
                   if (res.data.success) {
                        this.message.text = res.data.message;
                        this.message.success = true;
                    } else {
                        this.message.success = false;
                        this.message.text = res.data.message;
                    }
                }).catch(err => {
                    this.message.text = err.data.message;
                }); 
            },
            // キャビネットの共有から削除
            deleteShareCabine(cabinetId) {
              axios.post('/documents/document-management/delete-share-cabinet/' + cabinetId ,{
                    contract_id : this.editItem.agreements_or_folders_id,
                }).then(res => {
                   if (res.data.success) {
                        this.message.text = res.data.message;
                        this.message.success = true;
                        if (this.currentFolder.folder_id == res.data.folder_id) {
                            // 削除先のキャビネットと、今いるキャビネットが同一の場合は、一覧から削除
                            let index = this.items.indexOf(this.editItem);
                            this.items.splice(index, 1);
                        }
                    } else {
                        this.message.success = false;
                        this.message.text = res.data.message;
                    }
                }).catch(err => {
                    this.message.text = err.data.message;
                }); 
            },
            // フォルダへの移動
            moveFolder(folderId) {
              axios.post('/documents/document-management/move-contract/' + folderId ,{
                    name: this.editItem.name,
                    agreements_or_folders_id : this.editItem.agreements_or_folders_id,
                    isFolder : this.editItem.isFolder,
                    belongCabinetId: this.currentFolder.is_cabinet ? this.currentFolder.folder_id : this.currentFolder.cabinet_id,
                    currentFolderId: this.currentFolder.folder_id,
                }).then(res => {
                   if (res.data.success) {
                        this.message.text = res.data.message;
                        this.message.success = true;
                        // 一覧から削除
                            let index = this.items.indexOf(this.editItem);
                            this.items.splice(index, 1);
                    } else {
                        this.message.success = false;
                        this.message.text = res.data.message;
                    }
                }).catch(err => {
                    this.message.text = err.data.message;
                }); 
            },
            // グループの更新
            updateGroup(addItems, deleteItems) {
                axios.post("/documents/document-management/update-group" ,{
                    addItems: addItems,
                    deleteItems: deleteItems,
                    folderId: this.editItem.agreements_or_folders_id,
                }).then(res => {
                    if (res.data.success) {
                        this.validCabinetIds = res.data.cabinetValidIds?? this.validCabinetIds;
                        this.message.text = res.data.message;
                        this.message.success = true;
                    } else {
                        this.message.success = false;
                        this.message.text = res.data.message;
                    }
                }).catch(err => {
                    this.message.text = err.data.message;
                }); 
            },
            // アラートアイコン・アラート設定ボタンクリック時
            clickAlert(item) {
                axios.get('/documents/document-management/get-alert-auth/' + item.agreements_or_folders_id).then(res => {
                    if (!res.data.success) {
                        this.message.text = res.data.message;
                        this.message.success = res.data.success;
                        this.dialog.alert = false;
                    } else {
                        this.dialog.alert = true;
                        this.editItem = item;
                    }
                });
            },
            // ドットメニューの削除クリック時
            clickDotMenuDelete(item) {
                this.dialog.confirmDelete = true;
                this.editItem = item;
            },
            // ドットメニューの名前変更クリック時
            clickDotMenuRename(item) {
                this.dialog.rename = true;
                this.dialog.renameText = item.name;
                this.editItem = item;
            },
            // ドットメニューの共有 登録クリック時
            clickDotMenuShare(item) {
                this.editItem = item;
                axios.get('/documents/document-management/get-cabinet-list',{
                        params: {
                            name: this.editItem.name,
                            agreements_or_folders_id: item.agreements_or_folders_id,
                            is_delete: false,
                        }
                    }).then(res => {
                        this.dialog.share = true;
                        this.dialog.shareOrMoveMessage = res.data.message;
                        this.dialog.radioListItems = res.data.folders;
                });
            },
            // ドットメニューの共有 削除クリック時
            clickDotMenuDeleteShare(item) {
                this.editItem = item;
                axios.get('/documents/document-management/get-cabinet-list',{
                        params: {
                            name: this.editItem.name,
                            agreements_or_folders_id: item.agreements_or_folders_id,
                            is_delete: true,
                        }
                    }).then(res => {
                        this.dialog.shareDelete = true;
                        this.dialog.shareOrMoveMessage = res.data.message;
                        this.dialog.radioListItems = res.data.folders;
                });
            },
            // ドットメニューの移動クリック時
            clickDotMenuMove(item) {
                this.editItem = item;
                axios.get('/documents/document-management/get-folder-list',{
                        params: {
                            name: this.editItem.name,
                            agreements_or_folders_id: item.agreements_or_folders_id,
                            is_folder: item.isFolder,
                            cabinet_id: this.currentFolder.cabinet_id,
                        }
                    }).then(res => {
                        this.dialog.move = true;
                        this.dialog.shareOrMoveMessage = res.data.message;
                        this.dialog.radioListItems = res.data.folders;
                });
            },
            // ドットメニューのグループの編集クリック時
            clickEditMemberGroup(item, cabinetOwnerId) {
                this.editItem = item;
                axios.get('/documents/document-management/get-member-share-organizations' ,{
                    params: {
                        folderId: item.agreements_or_folders_id,
                    }
                }).then(res => {
                    this.allowedOrganis = res.data.allowed_organis;
                    this.notAllowedOrganis  = res.data.not_allowed_organis;
                    this.dialog.editMemberGroup = true;
                    this.dialog.cabinetOwnerIds.push(cabinetOwnerId);
                });
            },
            // アラートのセット
            setAlertData(...args) {
                const [contractAlertsId, agreementsId, alertDateTime, note, type, onOff, success, message] = args;
                // const [contractAlertsId, agreementsId, alertDateTime, note, type, onOff, snoozeOnOff, snoozeFrequency, success, message] = args;
                this.message.text = message;
                this.message.success = success;
                if (!success) {
                    return;   
                }
                this.editItem.contract_alerts_id = contractAlertsId;
                this.editItem.agreements_or_folders_id = agreementsId;
                this.editItem.alert_datetime = alertDateTime;
                this.editItem.note = note;
                this.editItem.type = type;
                this.editItem.alert_on_off = onOff;
                // this.editItem.alert_snooze_flag = snoozeOnOff;
                // this.editItem.alert_frequency_days = snoozeFrequency;
            },
            // 検索
            search(isInitPage = true) {
                if (isInitPage) {
                    // 最初のページを表示
                    this.indexInfo.page = 1;
                }
                
                this.loading = true;
                
                // 現在のフォルダの情報は初期化
                this.currentFolder.folder_id = null;
                this.currentFolder.is_cabinet = null;
                this.currentFolder.parent_folder_id = null;
                this.currentFolder.cabinet_id = null;
                
                let postSearchItem = this.searchItem;
                postSearchItem.lastUpdate.persons = [];
                postSearchItem.infoUpdate.persons = [];
                
                axios.get('/documents/document-management/view-search-result',{
                    params: {
                        searchItem: postSearchItem,
                    }
                }).then(res => {
                    // 項目一覧をセット
                    this.items = res.data.items;
                    this.depthInfo = res.data.depthInfo?? this.depthInfo;
                    this.searchItem.lastUpdate.persons = res.data.user_last_update_selects;
                    this.searchItem.infoUpdate.persons = res.data.user_contract_info_selects;
                    this.destNames = res.data.names;
                    this.enableCabinetBtn = false;
                    this.enableCompanyFunctionBtn = false;
                    this.alertAuths = res.data.alert_auths;
                    this.enableFolderBtn = false;
                    
                }) .finally(() => {
                    // 検索パネルを開いたままにする
                    this.searchPaNelno = 0;
                    this.loading = false;
                    this.insideFolder = false;
                    this.initIndex = false;
                    this.searchResult = true;
                    this.saveDocumentIndexInfos();
                });
            },
            // Vuexに検索条件やページの情報を保存
            saveDocumentIndexInfos(){
                this.$store.commit("saveDocumentIndexInfos",  { indexInfo: this.indexInfo, searchItem: this.searchItem, searchResult: this.searchResult });
            },
            // 契約情報最終更新日付
            getLastUpdatedContractInfoDate(item) {
                if (!item.contract_info_last_updated_date) {
                    return "";
                }
                let res = "";
                if (moment(new Date()).format('YYYY/MM/DD') == item.contract_info_last_updated_date) {
                    // 今日の場合は時間表示のみ
                    res = item.contract_info_last_updated_time;
                } else {
                    let w = new Date(item.contract_info_last_updated_date).getDay(); // 曜日
                    res = item.contract_info_last_updated_date + "(" + DAY_OF_WEEK[w] + ")";   
                }
                return res;
            },
            // 契約開始日が曜日つけ
            getStartDate(item) {
                if (!item.start_date ) {
                    return "";
                }
                let start_date = item.start_date.slice(0,-1);
                let res = "";
                let w = new Date(start_date).getDay(); // 曜日
                res = start_date + "(" + DAY_OF_WEEK[w] + ")～";
                return res;
            },
            
            // 契約終了日が曜日つけ
            getEndDate(item) {
                if (!item.end_date ) {
                    return "";
                }
                let res = "";
                let w = new Date(item.end_date).getDay(); // 曜日
                res = item.end_date + "(" + DAY_OF_WEEK[w] + ")";
                return res;
            },
            // 契約の進行状況を取得
            getContractStatus(item) {
                let date = item.last_update_signature_date;
                let name = item.last_update_name + " " + item.last_update_email_address;
                let status = "送信済み";
                
                if (item.status == this.contractStauses["STATUS_IMPORT"]) {
                    date = "";
                    name = "";
                    status = "";
                    
                } else if (item.status == this.contractStauses["STATUS_REJECTED"]) {
                    date = item.rejected_datetime;
                    status = "却下";
                    
                } else if (item.status == this.contractStauses["STATUS_CONCLUSION"]) {
                    date = item.conclusion_datetime;
                    status = "署名";
                    
                } else if (item.last_update_signature_status == this.signStatuses['SIGN_STATUS_TRANSFERRED']) {
                    date = "";
                    status =  "転送";
                        
                } else if (item.last_pending_opening_status == this.openingStatuses['STATUS_OPENED'] && 
                            item.next_user_signature_status == this.signStatuses['SIGN_STATUS_PENDING']) {
                    date = item.contract_opened_date;
                    name = item.last_pending_name + " " + item.last_pending_email_address;
                    status = "開封";
                        
                } else if (item.last_update_is_destination == 1) {
                    status = (item.last_update_is_authorizer == 1) ? "承認" : "署名";
                }
                
                let res = {
                    date: this.getDateOrTimeText(date) + " " + status,
                    name: name,
                };
                
                return res;
            },
            // 次の署名者の名前
            getNextSignerName(item) {
                if ((item.status == this.contractStauses["STATUS_REJECTED"]) || (item.status == this.contractStauses["STATUS_CONCLUSION"]) || item.is_uploaded_contract == 1) {
                    // 却下 or 締結済み or インポート書類の場合
                    return "";
                }
                return item.last_pending_name;
            },
            // 次の署名者の開封状況
            getNextSignerOpenStatus(item) {
                if ((item.status == this.contractStauses['STATUS_REJECTED']) || (item.status == this.contractStauses['STATUS_CONCLUSION']) || item.is_uploaded_contract == 1) {
                    // 却下 or 締結済み or インポート書類の場合
                    return "";
                }
                let res = "未送信";
                if (item.last_pending_opening_status == this.openingStatuses['STATUS_NOT_OPENED']) {
                    res = "未開封";
                } else if (item.last_pending_opening_status == this.openingStatuses['STATUS_OPENED']) {
                    res = "開封済";
                }
                return res;
            },
            // 送信先の名前取得
            getDestNames(isFolder, id) {
                if (isFolder || this.destNames == null) {
                    return "";
                }
                let vals = this.destNames[id];
                if (!vals) {
                    return "";
                }
                return vals.length > 0 ? vals.join(",") : vals[0];
            },
            // 表示するアイコンを取得
            getViewIcon(item) {
                if (item.is_uploaded_contract == 1) { // 文字列、数値の場合両対応
                    // インポート書類の場合
                    return "mdi-download";
                }
                let icon = "mdi-pdf-box";
                if (item.is_cabinet) {
                    icon = "mdi-archive-outline";
                } else if (item.isFolder) {
                    icon = "mdi-folder";
                }
                return icon;
            },
            // 検索条件の消去
            resetSearchItem() {
                this.searchItem.status.progress = null;
                this.searchItem.status.conclusion = null;
                this.searchItem.status.rejected = null;
                
                this.searchItem.openStatus.opened = null;
                this.searchItem.openStatus.unopened = null;
                
                this.searchItem.type.value = this.documentTypes['ALL_TYPE'];
                
                this.searchItem.contract_name = null;
                this.searchItem.infoUpdate.controlNumber = null;
                this.searchItem.infoUpdate.fromTransactionAmount = null;
                this.searchItem.infoUpdate.toTransactionAmount = null;
                this.searchItem.startDate = null;
                this.searchItem.endDate = null;
                this.searchItem.alertDate = null;
                this.searchItem.infoUpdate.value = null;
                this.searchItem.infoUpdate.date = null;
                this.searchItem.lastUpdate.value = null;
                this.searchItem.lastUpdate.date = null;
                
                this.searchItem.searchResult = false;
                
                if(this.searchItem.userItems) {
                    for (let item of this.searchItem.userItems) {
                        item.value = null;
                    }
                }
            },
            // sub検索条件画面
            alert: function (){
                this.addDialog = true;
            },
            enter:function (){
                this.addDialog = true;
            },
            //
            getIndividuals(postSearchItem) {
                axios.get('/documents/document-management/view-search-result',{
                    params: {
                        searchItem: postSearchItem,
                    }
                }).then(res => {
                    // 項目一覧をセット
                    this.items = res.data.items;
                    
                    this.searchItem.lastUpdate.persons = res.data.user_last_update_selects;
                    this.searchItem.infoUpdate.persons = res.data.user_contract_info_selects;
                    this.destNames = res.data.names;
                    this.enableCabinetBtn = false;
                    this.enableCompanyFunctionBtn = false;
                    this.alertAuths = res.data.alert_auths;
                    this.enableFolderBtn = false;
                    
                }) .finally(() => {
                    // 検索パネルを開いたままにする
                    this.searchPaNelno=0;
                    this.loading = false;
                    this.insideFolder = false;
                    this.initIndex = false;
                    this.searchResult = true;
                    this.saveDocumentIndexInfos();
                });
            },
        }
    };
</script>

<style scoped>
    ::v-deep th {
        word-break: keep-all;
        white-space : nowrap;
    }
    
    .search-item {
        margin-top : 0px;
        margin-bottom : 0px;
    }
    .item-td {
        cursor:pointer;
    }
    .second-row {
        display: flex;
        font-size: 15px;
    }
    .sendTo {
        height: 20px;
        margin-right: 3%;
        text-align: center;
    }
    .from {
        width: 50px;
        background-color: lightgray;
    }
    .to {
        width: 30px;
        margin-left: 5%;
        color: white;
        background-color: gray;
    }
    .button-margin-left {
        margin-left: 2%;
    }
    .v-input--checkbox {
        margin-right: 30px;
    }
    .current-item {
        color: red;
    }
    .info-from{
        width: 160PX;
        white-space: nowrap;
    }
    .info-to{
        width: 50%;
        white-space: nowrap;
        text-overflow:ellipsis;
        overflow:hidden;
    }
    .between-mark {
        text-align: center;
        margin-top: 20px;
    }
    
    .slide-enter-active {
      animation: slide-in 0s;
    }
    
    .slide-leave-active {
      animation: slide-in 0s reverse;
    }
    .v-enter-active, .v-leave-active {
        transition: opacity 0s
    }
    
    .v-enter, .v-leave-to{
        opacity: 0;
    }
    @keyframes slide-in {
      from {
        transform: translateX(100px);
      }
      to {
        transform: translateX(0px);
      }
    }
    .w50per{
        width: 50%;
    }
    .positfixed{
        position: fixed;
    }
    .positfixedSearch{
        position: fixed;
        z-index: 30;
        
        background:white;
        top:40px;
        right:15px;
        height: 80px;
    }
    .positabsolute{
        position: absolute;
    }
    
    .disableCabinet {
        /*color:gray !important;*/
        opacity: 0.5
    }
    .searchLabel{
        right:0px;
        width: 70px;
        height: 70px;
        z-index: 30;
        position: fixed;
        border-radius: 8px 0 0 8px;
        background:white;
        box-shadow: 10px 5px 5px black;
    }
    .searchLabel.active{
        /*ラベルがクリックされたとき*/
        z-index: 31;
        position: fixed;
        top:48px;
        right:calc(50%);
        width: 70px;
        height: 70px;
        border: 1px solid lightgrey;
        border-right:none;
        box-shadow:none;
        
    }
    .searchRow{
        margin: 0px;
        padding: 0px;
        list-style-type: none;
        position: fixed;
        background-color: #FFFFFF;
    }
</style>
